/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateRateInput = {|
  rate?: ?number,
  roleId?: ?string,
  rateCardId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createRateMutationVariables = {|
  input: CreateRateInput
|};
export type createRateMutationResponse = {|
  +createRate: ?{|
    +rate: ?{|
      +node: ?{|
        +id: string,
        +rate: ?number,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
      |}
    |}
  |}
|};
export type createRateMutation = {|
  variables: createRateMutationVariables,
  response: createRateMutationResponse,
|};
*/


/*
mutation createRateMutation(
  $input: CreateRateInput!
) {
  createRate(input: $input) {
    rate {
      node {
        id
        rate
        role {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateRateInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateRatePayload",
    "kind": "LinkedField",
    "name": "createRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RateTypeEdge",
        "kind": "LinkedField",
        "name": "rate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Rate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createRateMutation",
    "operationKind": "mutation",
    "text": "mutation createRateMutation(\n  $input: CreateRateInput!\n) {\n  createRate(input: $input) {\n    rate {\n      node {\n        id\n        rate\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00839861e857a8eda954c4df0180b76d';

module.exports = node;
